export default __webpack_public_path__ + "static/media/percent_icon.9a4bf083.svg";